/*
 * @description:
 * @Author: wxy
 * @Date: 2019-02-02 14:31:07
 */
import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/Layout'
import mLayout from '@/views/layout/mLayout'
import communityLayout from '@/views/community/components/CommunityLayout'

Vue.use(Router)

/** note: submenu only apppear when children.length>=1
 *   detail see  https://panjiachen.github.io/vue-element-admin-site/#/router-and-nav?id=sidebar
 **/

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']     will control the page roles (you can set multiple roles)
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
    noCache: true                if true ,the page will no be cached(default is false)
  }
 **/
export default new Router({
  routes: [
    // 移动端路由
    {
      path: '/mobile',
      component: mLayout,
      children: [{
        path: 'userCenter',
        component: () => import('@/views/userCenter/index'),
        name: 'mUserCenter'
      },
      {
        path: 'information',
        component: () => import('@/views/cms/information/list_mobile'),
        name: 'mInformation'
      },
      {
        path: 'informationList/-1',
        component: () => import('@/views/cms/information/list_mobile'),
        name: 'mInformationList'
      },
      {
        path: 'hotel',
        component: () => import('@/views/administration/hotel/list/appIndex'),
        name: 'mHotel'
      },
      {
        path: 'hotelDetail',
        component: () =>
						import('@/views/administration/hotel/list/appHotelDetail'),
        name: 'mHotelDetail'
      },
      {
        path: 'confirmGrant',
        component: () => import('@/views/officeSupplies/mobileConfirmGrant'),
        name: 'confirmGrant'
      },
      {
        path: '/information/infoShow',
        component: () => import('@/views/cms/information/infoM'),
        name: 'informationInfoShow'
      },
      {
        path: 'reserve',
        component: () =>
						import('@/views/administration/meetRoom/reserve/reserveLayoutM'),
        children: [{
          path: 'add',
          component: () =>
								import('@/views/administration/meetRoom/reserve/reserveM'),
          name: 'mReserve'
        },
        {
          path: 'meetroomInfo',
          component: () =>
								import('@/views/administration/meetRoom/reserve/reserveMInfo'),
          name: 'mReserveInfo'
        },
        {
          path: 'list',
          component: () =>
								import('@/views/administration/meetRoom/reserve/reserveMList'),
          name: 'mReserveList'
        },
        {
          path: 'reserve',
          component: () =>
								import(
								  '@/views/administration/meetRoom/reserve/needAttendingList'
								),
          name: 'needAttendingList'
        }
        ]
      },
      {
        path: '/cms/comment',
        component: () => import('@/views/cms/information/comment'),
        name: 'cmsComment'
      },
      {
        path: '/userInfoM',
        name: 'userInfoM',
        component: () => import('@/views/userInfoM')
      },
      {
        path: '/userInfoMForm',
        name: 'userInfoMForm',
        component: () => import('@/views/userInfoM/form')
      },
      {
        path: '/userInfoMLogin',
        name: 'userInfoMLogin',
        component: () => import('@/views/userInfoM/login')
      },
      {
        path: '/attendanceMap/detail',
        name: 'attendanceMapDetail',
        component: () => import('@/views/attendanceMap/detail')
      },
      {
        path: '/information/clientViewM',
        component: () => import('@/views/cms/information/clientView'),
        name: 'clientViewM'
      },
        // 社区
      {
        path: 'community',
        component: () => import('@/views/communityM/components/Layout'),
        children: [{
          path: 'list',
          component: () => import('@/views/communityM/communityList'),
          name: 'communityListM'
        },
        {
          path: 'add',
          component: () => import('@/views/communityM/add'),
          name: 'addCommunityM'
        },
        {
          path: 'info',
          component: () => import('@/views/communityM/info'),
          name: 'communityInfoM'
        },
        {
          path: 'publishList',
          component: () => import('@/views/communityM/publishList'),
          name: 'communityPublishListM'
        },
        {
          path: 'storeList',
          component: () => import('@/views/communityM/storeList'),
          name: 'communityStoreListM'
        }
          // {
          //   path: 'clientViewM',
          //   component: () => import('@/views/cms/information/clientView'),
          //   name: 'clientViewM'
          // },
        ]
        // 云上青年投票
      },
      {
        path: 'vote/youth',
        component: () => import('@/views/voteForYouth'),
        name: 'voteForYouth'
      },

        // 个人报销
      {
        path: 'reimbursement/order',
        component: () => import('@/views/reimbursement/InvoiceOrder'),
        name: 'invoiceOrderM'
      },
      {
        path: 'convergeDetailM',
        component: () => import('@/views/reimbursement/convergeDetail'),
        name: 'convergeDetailM'
      },
      {
        path: 'printSummaryOrder',
        component: () => import('@/views/reimbursement/PrintSummaryOrder'),
        name: 'printSummaryOrder'
      },
      {
        path: 'PrintInvoice',
        component: () => import('@/views/reimbursement/PrintInvoice'),
        name: 'printInvoice'
      },
      {
        path: 'submitInvoiceM',
        component: () => import('@/views/reimbursement/SubmitInvoiceM'),
        name: 'submitInvoiceM'
      },
      {
        path: 'myOrderListM',
        component: () => import('@/views/reimbursement/MyOrderListM'),
        name: 'myOrderListM'
      },
      {
        path: 'billingMake',
        component: () => import('@/views/reimbursement/billingMake'),
        name: 'billingMake'
      },
      {
        path: 'accreditation',
        component: () => import('@/views/reimbursement/accreditation'),
        name: 'accreditation'
      },
      {
        path: 'invoiceValidate',
        component: () => import('@/views/reimbursement/invoiceValidate'),
        name: 'invoiceValidate'
      },
        // 打卡提醒
      {
        path: 'punchInReminder',
        component: () => import('@/views/punchInReminder'),
        name: 'punchInReminder'
      },
      {
        path: 'punchInRanking',
        component: () => import('@/views/punchInReminder/ranking'),
        name: 'punchInRanking'
      },
      {
        path: 'punchInList',
        component: () => import('@/views/punchInReminder/list'),
        name: 'punchInList'
      },
        // 日程管理移动端
      {
        path: 'planM',
        component: () =>
						import('@/views/dashboard/components/calendar/planM'),
        name: 'planM'
      },

        // 培训
      {
        path: 'train/info',
        component: () => import('@/views/train/info'),
        name: 'trainInfoM'
      },
      {
        path: 'train/attendanceList',
        component: () => import('@/views/train/attendanceList'),
        name: 'attendanceListM'
      },
      {
        path: 'train',
        component: () => import('@/views/train/trainLayoutM'),
        children: [{
          path: 'list',
          component: () => import('@/views/train/listM'),
          name: 'trainListM'
        },
        {
          path: 'mylist',
          component: () => import('@/views/train/myListM'),
          name: 'myTrainListM'
        }
        ]
      },

        // 意见反馈
      {
        path: 'suggestionManagement',
        component: () => import('@/views/suggestionManagement/index'),
        name: 'suggestionManagementM'
      },

        // 日程
      {
        path: 'schedule/list',
        component: () => import('@/views/scheduleM/index'),
        name: 'scheduleList'
      },
      {
        path: 'schedule/add',
        component: () => import('@/views/scheduleM/add'),
        name: 'addSchedule'
      },
        // 重定向
      {
        path: 'redirectByUrl',
        name: 'redirectByUrlM',
        component: () => import('@/views/redirectByUrl')
      }
      ]
    },

    // pc端路由
    {
      path: '/',
      name: 'filterUrl',
      component: () => import('@/views/filterUrl')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login')
    },
    {
      path: '/retrieve',
      name: 'retrieve',
      component: () => import('@/views/login/retrievePassward')
    },
    {
      path: '/download',
      name: 'download',
      component: () => import('@/views/download/download')
    },
    {
      path: '/changepwd',
      name: 'changepwd',
      component: () => import('@/views/changepwd')
    },
    // 员工入职登记表
    {
      path: '/entryForm',
      component: () => import('@/views/staffing/entryForm/login'),
      name: 'entryForm'
    },
    {
      path: '/entryForm/add',
      component: () => import('@/views/staffing/entryForm'),
      name: 'addEntryForm'
    },
    {
      path: '/entryForm/print',
      component: () => import('@/views/staffing/entryForm/printPage'),
      name: 'printEntryForm'
    },
    {
      path: '/dashboard',
      component: Layout,
      redirect: 'dashboard',
      children: [{
        path: '/htmlPage/:url',
        name: 'htmlPage',
        component: () => import('@/views/html/index')
      },
      {
        path: '/test',
        name: 'test',
        component: () => import('@/components/tableUnit/test')
      },
      {
        path: '/dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'dashboard',
        meta: {
          title: 'dashboard',
          noCache: true
        }
      },
      {
        path: '/salary/list',
        component: () => import('@/views/salary/list'),
        name: 'salary',
        meta: {
          title: 'salary',
          noCache: true
        }
      },
      {
        path: '/404/notfound',
        component: () => import('@/views/errorPage/404'),
        name: 'notfound',
        meta: {
          title: 'notfound',
          noCache: true
        }
      },
      {
        path: '/changeLoginPassword',
        component: () => import('@/views/changepwd/changeLoginPassword'),
        name: 'changeLoginPassword',
        meta: {
          title: 'changeLoginPassword',
          noCache: true
        }
      },
      {
        path: '/frameIndex',
        component: () => import('@/views/frame/index'),
        name: 'frameIndex',
        meta: {
          title: 'frameIndex',
          noCache: true
        }
      },
      {
        path: '/frame',
        component: () => import('@/views/frame/frame'),
        name: 'frame',
        meta: {
          title: 'frame',
          noCache: true
        }
      }
      ]
    },

    // 系统管理
    {
      path: '/systemManagement',
      component: Layout,
      // redirect: 'systemManagement',
      children: [{
        path: 'project',
        component: () => import('@/views/systemManage/project/index'),
        name: 'project'
      },
      {
        path: 'projectInfo',
        component: () => import('@/views/systemManage/project/info'),
        name: 'projectInfo'
      },
      {
        path: '/systemConfig',
        component: () => import('@/views/systemManage/configuration/index'),
        name: 'systemConfig'
      },
      {
        path: '/masterData',
        component: () => import('@/views/systemManage/masterData/index'),
        name: 'masterData'
      },
      {
        path: 'post',
        component: () => import('@/views/systemManage/post/list'),
        name: 'systemManagementPost'
      },
      {
        path: 'email', // 邮箱配置
        component: () => import('@/views/systemManage/email/list'),
        name: 'emailConfig'
      },
      {
        path: 'addEmailConfig', // 添加邮箱配置
        component: () => import('@/views/systemManage/email/add'),
        name: 'addEmailConfig'
      },
      {
        path: 'uploadFileList', // 上传文件管理
        component: () => import('@/views/systemManage/uploadFileList'),
        name: 'uploadFileList'
      },
      {
        path: 'workStatus',
        component: () => import('@/views/systemManage/workStatus/list'),
        name: 'workStatus'
      },
      {
        path: 'homepageConfig',
        component: () => import('@/views/systemManage/homepageConfig/index'),
        name: 'homepageConfig'
      }
      ]
    },

    // 个人中心
    {
      path: '/userCenter',
      component: Layout,
      children: [{
        path: '/userCenter',
        component: () => import('@/views/userCenter/index'),
        name: 'userCenter'
      },
      {
        path: '/annualVacationInfo',
        component: () => import('@/views/userCenter/annualVacationInfo'),
        name: 'annualVacationInfo'
      }
      ]
    },
    // 通讯录
    {
      path: '/addressList',
      component: Layout,
      children: [{
        path: 'addressList',
        component: () => import('@/views/address-list/index'),
        name: 'addressList'
      }]
    },
    // 定时器
    {
      path: '/timer',
      component: Layout,
      children: [{
        path: 'timer',
        component: () => import('@/views/timer/index'),
        name: 'timer'
      }]
    },
    // 发票夹
    {
      path: '/receiptList',
      component: Layout,
      children: [{
        path: 'receiptList',
        component: () => import('@/views/receiptList/index'),
        name: 'receiptList'
      }]
    },
    // 考勤信息
    {
      path: '/attendanceInformation',
      component: Layout,
      children: [{
        path: 'attendanceInformation',
        component: () => import('@/views/attendanceInformation/index'),
        name: 'attendanceInformation'
      },
      {
        path: 'department',
        component: () => import('@/views/attendanceInformation/department'),
        name: 'departmentAttendanceInformation'
      }
      ]
    },
    // 办公用品
    {
      path: '/officeSupplies',
      component: Layout,
      children: [{
        path: 'apply',
        component: () => import('@/views/officeSupplies/apply'),
        name: 'apply'
      },
      {
        path: 'summary',
        component: () => import('@/views/officeSupplies/summary'),
        name: 'summary'
      },
      {
        path: 'goodManage',
        component: () => import('@/views/officeSupplies/goodManage'),
        name: 'goodManage'
      },
      {
        path: 'attendanceInformation',
        component: () =>
						import('@/views/officeSupplies/attendanceInformation'),
        name: 'attendanceInformation'
      },
      {
        path: 'confirmGrant',
        component: () => import('@/views/officeSupplies/confirmGrant'),
        name: 'confirmGrant'
      }
      ]
    },
    // 人事
    {
      path: '/staffing',
      component: Layout,
      // redirect: 'systemManagement',
      children: [{
        path: 'organize',
        component: () => import('@/views/staffing/organize'),
        name: 'organize'
      },
      {
        path: '/roleManagement',
        component: () => import('@/views/staffing/organize/roleManagement'),
        name: 'roleManagement'
      },
      {
        path: 'addStaff',
        component: () => import('@/views/staffing/organize/addStaff'),
        name: 'addStaff'
      },
      {
        path: 'post',
        component: () => import('@/views/staffing/post'),
        name: 'staffing-post'
      },
      {
        path: '/department',
        component: () => import('@/views/staffing/department'),
        name: 'department'
      },
      {
        path: '/recruit',
        component: () => import('@/views/staffing/recruit'),
        name: 'recruit'
      },
      {
        path: '/startRecruit',
        component: () => import('@/views/staffing/recruit/startRecruit'),
        name: 'startRecruit'
      },
      {
        path: '/talentManagement',
        component: () => import('@/views/staffing/talentManagement'),
        name: 'talentManagement'
      },
      {
        path: '/listConfig',
        component: () => import('@/views/staffing/listConfig'),
        name: 'listConfig'
      },
        // 员工基本信息登记表列表页
      {
        path: '/entryForm/list',
        component: () => import('@/views/staffing/entryForm/list'),
        name: 'entryFormList'
      },
      {
        path: '/entryForm/experience',
        component: () => import('@/views/staffing/entryForm/experience'),
        name: 'experience'
      },
        // 员工资格证书管理页
      {
        path: '/study',
        component: () => import('@/views/staffing/study/index'),
        name: 'studyExperienceInfo'
      },
      {
        path: '/study/userAdd',
        component: () => import('@/views/staffing/study/userAdd'),
        name: 'studyUserAdd'
      },
        // 请销假
      {
        path: '/offWork',
        component: () => import('@/views/staffing/offWork'),
        name: 'offWork'
      }
      ]
    },
    {
      path: '/department/addPosition',
      component: () => import('@/views/staffing/department/addPosition'),
      name: 'addPosition'
    },

    // 资产
    {
      path: '/asset',
      component: Layout,
      // redirect: 'systemManagement',
      children: [{
        path: '/list',
        component: () => import('@/views/asset/assetList'),
        name: 'assetList'
      },
      {
        path: '/importAsset',
        component: () => import('@/views/asset/assetList/importAsset'),
        name: 'importAsset'
      },
      {
        path: '/class',
        component: () => import('@/views/asset/class'),
        name: 'assetClass'
      },
      {
        path: '/machineRoom',
        component: () => import('@/views/asset/machineRoom'),
        name: 'machineRoom'
      },
      {
        path: '/addSN',
        component: () => import('@/views/asset/addSN'),
        name: 'addSN'
      }
      ]
    },

    // 行政
    {
      path: '/administration',
      component: Layout,
      children: [{
        path: '/attendance',
        component: () => import('@/views/administration/attendance'),
        name: 'attendance'
      },
      {
        path: '/meetRoom',
        component: () => import('@/views/administration/meetRoom'),
        name: 'meetRoom'
      },
      {
        path: '/uMeetRoom',
        component: () =>
						import('@/views/administration/meetRoom/reserve/uindex'),
        name: 'uMeetRoom'
      },
      {
        path: '/meetRoom/reserve/list',
        component: () =>
						import('@/views/administration/meetRoom/reserve/reserve'),
        name: 'reserveMeetRoom'
      },
      {
        path: '/meeting/list',
        component: () =>
						import('@/views/administration/meetRoom/reserve/meetList'),
        name: 'meetingList'
      },
      {
        path: '/meetRoom/reserve',
        component: () =>
						import('@/views/administration/meetRoom/reserve/list'),
        name: 'reserveMeetRoomList'
      },
      {
        path: '/hotel/management',
        component: () => import('@/views/administration/hotel/management'),
        name: 'hotelManagement'
      },
      {
        path: '/hotel/list',
        component: () => import('@/views/administration/hotel/list'),
        name: 'hotelList'
      },
      {
        path: '/hotel/detail',
        component: () =>
						import('@/views/administration/hotel/list/hotelDetail'),
        name: 'hotelDetail'
      },
      {
        path: '/administration/correctAttendance',
        component: () => import('@/views/administration/correctAttendance'),
        name: 'attendanceCorrect'
      }
      ]
    },

    // 项目
    {
      path: '/project',
      component: Layout,
      children: [{
        path: '/require',
        component: () => import('@/views/project/base'),
        children: [{
          path: '/personal',
          component: () => import('@/views/project/personalRequirement'),
          name: 'personalRequirement'
        },
        {
          path: '/department',
          component: () => import('@/views/project/departmentRequirement'),
          name: 'departmentRequirement'
        }
        ]
      }]
    },

    // 流程管理
    {
      path: '/bpm',
      component: Layout,
      children: [{
        path: '/homePage',
        component: () => import('@/views/bpmManagement/homePage'),
        name: 'bpmHomePage'
      },
      {
        path: '/homeMenu',
        component: () => import('@/views/bpmManagement/homeMenu'),
        name: 'homeMenu'
      }
        // {
        //   path: '/todoList',
        //   component: () =>
        //     import('@/views/bpmManagement/todoList'),
        //   name: 'todoList'
        // },
        // {
        //   path: '/createdList',
        //   component: () =>
        //     import('@/views/bpmManagement/createdList'),
        //   name: 'createdList'
        // },
        // {
        //   path: '/doneList',
        //   component: () =>
        //     import('@/views/bpmManagement/doneList'),
        //   name: 'doneList'
        // },
        // {
        //   path: '/draftList',
        //   component: () =>
        //     import('@/views/bpmManagement/draftList'),
        //   name: 'draftList'
        // }
      ]
    },

    // cms
    {
      path: '/cms',
      component: Layout,
      children: [{
        path: '/column',
        component: () => import('@/views/cms/column'),
        name: 'column'
      },
      {
        path: '/information/List',
        component: () => import('@/views/cms/information'),
        name: 'informationList'
      },
      {
        path: '/information/add',
        component: () => import('@/views/cms/information/add'),
        name: 'addInformation'
      },
      {
        path: '/information/addRule',
        component: () => import('@/views/cms/information/addRule'),
        name: 'addInformationRule'
      },
      {
        path: '/information',
        component: () =>
						import('@/views/cms/information/components/CmsLayout'),
        children: [{
          path: 'info',
          component: () => import('@/views/cms/information/info'),
          name: 'informationInfo'
        },
        {
          path: '/information/clientView',
          component: () => import('@/views/cms/information/clientView'),
          name: 'clientView'
        },
        {
          path: '/information/zpClientView',
          component: () => import('@/views/cms/information/zpClientView'),
          name: 'zpClientView'
        }
        ]
      },
      {
        path: '/information/sendEmail',
        component: () => import('@/views/cms/information/sendEmail'),
        name: 'sendEmail'
      }
      ]
    },

    // 日报（只包含静态页面）
    {
      path: '/dailyReport',
      component: Layout,
      children: [{
        path: '/',
        component: () => import('@/views/dailyReport'),
        name: 'dailyReport'
      },
      {
        path: '/info',
        component: () => import('@/views/dailyReport/info'),
        name: 'dailyReportInfo'
      }
      ]
    },

    // toolBar测试（右侧快捷键，包含生日、回顶部等功能，暂时没有用到）
    {
      path: '/tools',
      component: Layout,
      children: [{
        path: '/',
        component: () => import('@/views/layout/components/toolBar'),
        name: 'tools'
      }]
    },
    // 邮件
    {
      path: '/',
      component: Layout,
      children: [{
        path: '/mail/templateList',
        component: () => import('@/views/mail/templateList'),
        name: 'mailTemplateList'
      },
      {
        path: '/mail/templateForm',
        component: () => import('@/views/mail/templateForm'),
        name: 'templateForm'
      },
      {
        path: '/mail/sendMail',
        component: () => import('@/views/mail/sendMail'),
        name: 'sendMail'
      }
      ]
    },
    {
      path: '/knowledge',
      component: Layout,
      children: [{
        path: '/knowledge',
        component: () => import('@/views/knowledge/knowledge'),
        name: 'knowledge'
      }]
    },
    // 服务号
    {
      path: '/',
      component: Layout,
      children: [{
        path: '/service',
        component: () => import('@/views/service'),
        name: 'service'
      },
      {
        path: '/addService',
        component: () => import('@/views/service/addService'),
        name: 'addService'
      },
      {
        path: '/serviceInfo',
        component: () => import('@/views/service/serviceInfo'),
        name: 'serviceInfo'
      },
      {
        path: '/sendMessage',
        component: () => import('@/views/service/sendMessage'),
        name: 'sendMessage'
      },
      {
        path: '/autoResponse',
        component: () => import('@/views/service/autoResponse'),
        name: 'autoResponse'
      },
      {
        path: '/customizedMenu',
        component: () => import('@/views/service/customizedMenu'),
        name: 'customizedMenu'
      }
      ]
    },
    // 工时申报
    {
      path: '/',
      component: Layout,
      children: [{
        path: '/workTime',
        component: () => import('@/views/workTime/workTime'),
        name: 'workTime'
      }]
    },
    // 社区
    {
      path: '/',
      component: Layout,
      children: [{
        path: 'community',
        component: communityLayout,
        children: [{
          path: 'list',
          component: () => import('@/views/community'),
          name: 'community'
        },
        {
          path: 'info',
          component: () => import('@/views/community/info'),
          name: 'communityInfo'
        },
        {
          path: 'add',
          component: () => import('@/views/community/add'),
          name: 'addCommunity'
        },
        {
          path: 'publishList',
          component: () => import('@/views/community/publishList'),
          name: 'publishList'
        },
        {
          path: 'messageList',
          component: () => import('@/views/community/messageList'),
          name: 'messageList'
        }
        ]
      }]
    },
    {
      path: '/',
      component: Layout,
      children: [{
        path: 'staffInfo',
        component: () => import('@/views/staffing/organize/staffInfo'),
        name: 'staffInfo'
      },
      {
        path: 'importExcel',
        component: () => import('@/views/importExcel/importExcel'),
        name: 'importExcel'
      }
      ]
    },
    // 个人报销
    {
      path: '/reimbursement',
      component: Layout,
      children: [{
        path: 'submitInvoice',
        component: () => import('@/views/reimbursement/SubmitInvoice'),
        name: 'submitInvoice'
      },
      {
        path: 'orderList',
        component: () => import('@/views/reimbursement/OrderList'),
        name: 'orderList'
      },
      {
        path: 'convergeDetail',
        component: () => import('@/views/reimbursement/convergeDetail'),
        name: 'convergeDetail'
      },
      {
        path: 'myOrderList',
        component: () => import('@/views/reimbursement/MyOrderList'),
        name: 'myOrderList'
      },
      {
        path: 'order',
        component: () => import('@/views/reimbursement/InvoiceOrder'),
        name: 'invoiceOrder'
      },
      {
        path: 'proportionList/department',
        component: () =>
						import('@/views/reimbursement/ProportionListDepartment'),
        name: 'proportionListDepartment'
      },
      {
        path: 'proportionList/emplayee',
        component: () =>
						import('@/views/reimbursement/ProportionListEmployee'),
        name: 'proportionListEmployee'
      },
      {
        path: 'proportionList/company',
        component: () =>
						import('@/views/reimbursement/ProportionListCompony'),
        name: 'proportionListCompony'
      },
      {
        path: 'billing',
        component: () => import('@/views/reimbursement/billing'),
        name: 'billing'
      },
      {
        path: 'importHrCodeExcel',
        component: () => import('@/views/reimbursement/importHrCodeExcel'),
        name: 'importHrCodeExcel'
      },
      {
        path: 'scanQRcodeForSummaryOrder',
        component: () => import('@/views/reimbursement/scanQRcodeForSummaryOrder'),
        name: 'scanQRcodeForSummaryOrder'
      },
      {
        path: 'scanQRcodeForInvoiceOrder',
        component: () => import('@/views/reimbursement/scanQRcodeForInvoiceOrder'),
        name: 'scanQRcodeForInvoiceOrder'
      }
        // {
        //   path: 'order',
        //   component: () => import('@/views/reimbursement/InvoiceOrder'),
        //   name: 'invoiceOrder'
        // }
      ]
    },
    // 项目机会管理
    {
      path: '/project/chance',
      component: Layout,
      children: [{
        path: 'list',
        component: () => import('@/views/projectChanceManagement/list'),
        name: 'projectChanceList'
      },
      {
        path: 'add',
        component: () => import('@/views/projectChanceManagement/add'),
        name: 'addProjectChance'
      },
      {
        path: 'permission',
        component: () => import('@/views/projectChanceManagement/permission'),
        name: 'projectChancePermission'
      }
      ]
    },
    {
      path: '/',
      component: Layout,
      children: [{
        path: '/exportExcel/bpm',
        component: () => import('@/views/exportExcel/BPMExport'),
        name: 'BPMExport'
      },
      {
        path: '/exportExcel/standingBook',
        component: () => import('@/views/exportExcel/standingBook'),
        name: 'standingBook'
      },
      {
        path: '/exportExcel/sysDataExport',
        component: () => import('@/views/exportExcel/sysDataExport'),
        name: 'sysDataExport'
      }
      ]
    },
    // 意见反馈
    {
      path: '/',
      component: Layout,
      children: [{
        path: '/suggestionManagement',
        component: () => import('@/views/suggestionManagement/index'),
        name: 'suggestionManagement'
      }]
    },
    // 培训
    {
      path: '/train',
      component: Layout,
      children: [{
        path: 'management',
        component: () => import('@/views/train/management'),
        name: 'trainManagement'
      },
      {
        path: 'add',
        component: () => import('@/views/train/add'),
        name: 'trainAdd'
      },
      {
        path: 'list',
        component: () => import('@/views/train/list'),
        name: 'trainList'
      },
      {
        path: 'info',
        component: () => import('@/views/train/info'),
        name: 'trainInfo'
      }
      ]
    },
    // 意见反馈
    {
      path: '/evaluation',
      component: Layout,
      children: [{
        path: 'list',
        component: () => import('@/views/evaluation/list'),
        name: 'evaluationList'
      },
      {
        path: 'add',
        component: () => import('@/views/evaluation/add'),
        name: 'evaluationAdd'
      }
      ]
    },
    // 考勤导入 importAttendanceRecord
    {
      path: '/importAttendanceRecord',
      component: Layout,
      children: [{
        path: 'importAttendanceRecord',
        component: () => import('@/views/attendanceInformation/importAttendanceRecord'),
        name: 'importAttendanceRecord',
        meta: {
          title: 'importAttendanceRecord',
          noCache: true
        }
      }]
    },
    // 考勤查询 attendanceRecordSeach
    {
      path: '/attendanceRecordSeach',
      component: Layout,
      children: [{
        path: 'attendanceRecordSeach',
        component: () => import('@/views/attendanceInformation/attendanceRecordSeach'),
        name: 'attendanceRecordSeach',
        meta: {
          title: 'attendanceRecordSeach',
          noCache: true
        }
      }]
    },
    // 月考勤记录查询 monthAttendanceRecordSeach
    {
      path: '/monthAttendanceRecordSeach',
      component: Layout,
      children: [{
        path: 'monthAttendanceRecordSeach',
        component: () => import('@/views/attendanceInformation/monthAttendanceRecordSeach'),
        name: 'monthAttendanceRecordSeach',
        meta: {
          title: 'monthAttendanceRecordSeach',
          noCache: true
        }
      }]
    },
    // 考勤日历
    {
      path: '/checkCalendar',
      component: Layout,
      children: [{
        path: 'checkCalendar',
        component: () => import('@/views/examine/checkCalendar'),
        name: 'checkCalendar',
        meta: {
          title: 'checkCalendar',
          noCache: true
        }
      }]
    },
    // 补签管理
    {
      path: '/retroactive',
      component: Layout,
      children: [{
        path: 'retroactive',
        component: () => import('@/views/examine/retroactive'),
        name: 'retroactive',
        meta: {
          title: 'retroactive',
          noCache: true
        }
      }]
    },
    // 项目管理
    {
      path: '/projectManagement',
      component: Layout,
      children: [
        // 项目全表
        {
          path: 'full',
          component: () => import('@/views/projectManagement/full'),
          name: 'full',
          meta: {
            title: 'full',
            noCache: true
          }
        },
        // 项目全表添加页
        {
          path: 'fullAdd',
          component: () => import('@/views/projectManagement/full/add'),
          name: 'fullAdd',
          meta: {
            title: 'fullAdd',
            noCache: true
          }
        },
        // 里程碑页
        {
          path: 'milepost',
          component: () => import('@/views/projectManagement/milepost'),
          name: 'milepost',
          meta: {
            title: 'milepost',
            noCache: true
          }
        },
        // 里程碑添加表
        {
          path: 'mileAdd',
          component: () => import('@/views/projectManagement/milepost/add'),
          name: 'mileAdd',
          meta: {
            title: 'mileAdd2',
            noCache: true
          }
        },
        // 项目预算表
        {
          path: 'budget',
          component: () => import('@/views/projectManagement/budget'),
          name: 'budget',
          meta: {
            title: 'budget',
            noCache: true
          }
        },
        // 项目预算添加表
        {
          path: 'budAdd',
          component: () => import('@/views/projectManagement/budget/add'),
          name: 'budAdd',
          meta: {
            title: 'budAdd',
            noCache: true
          }
        }
      ]
    },
    {
      path: '/breakOff',
      component: Layout,
      children: [
        {
          path: 'breakOff',
          component: () => import('@/views/breakOff/breakOff'),
          name: 'breakOff',
          meta: {
            title: 'breakOff',
            noCache: true
          }
        }
      ]
    },
    {
      path: '/yearHoliday',
      component: Layout,
      children: [
        {
          path: 'yearHoliday',
          component: () => import('@/views/yearHoliday/yearHoliday'),
          name: 'yearHoliday',
          meta: {
            title: 'yearHoliday',
            noCache: true
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js